import type { HttpResponse } from '@angular/common/http';

export function parseFilenameFromResponse(response: HttpResponse<Blob>): string | null {
  const contentDisposition = response.headers.get('Content-Disposition');

  if (contentDisposition === null) {
    return null;
  }

  // 1. Find the filename header parameter and capture the text between quotes or until the separator
  const utf8Regex = /filename\*\s*=\s*([^;\n]+)/i;
  const utf8Matches = utf8Regex.exec(contentDisposition);

  if (utf8Matches?.[1] !== undefined) {
    const rawValue = utf8Matches[1].replaceAll('"', '');
    const encodedFileName = rawValue.split("'").slice(2).join("'");

    try {
      return decodeURIComponent(encodedFileName);
    } catch (error) {
      console.warn('Failed to decode UTF-8 filename', error);
    }
  }

  // 2. Fallback to legacy 'filename=' if 'filename*' is missing or fails decoding
  const standardRegex = /filename\s*=\s*((['"]).*?\2|[^;\n]*)/i;
  const standardMatches = standardRegex.exec(contentDisposition);

  if (standardMatches?.[1] === undefined) {
    return null;
  }

  // Remove quotes if present
  return standardMatches[1].replace(/['"]/g, '');
}
